export const getShops = (state) => state.shops
export const getShop = (state) => state.shop
export const isLoading = (state) => state.loading
export const getPagination = (state) => state.pagination
export const getShopById = (state) => (id) => state.shops.find(shop => shop.id === id)
export const getAvailableStores = (state) => state.availableStores
export const getCurrentShopId = (state) => state.currentShopId
